import './NevadaLaborSettings.scss';

import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Checkbox from 'fe-design-base/atoms/Checkbox';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link';
import PropTypes from 'prop-types';

import { getCurrentLocationStateName } from 'selectors/session';

import { toI18n } from 'util/i18n';

const NEVADA_LABOR_LAWS_URL =
  'https://joinhomebase.com/state-labor-laws/nevada/';

const NevadaLaborSettings = ({
  job,
  cxEl,
  editMode,
  stateCode,
  setFieldValue,
  isAContractor,
  verticalLayout,
  fourTensRuleEnabledValue, // used for creating a new job
}) => {
  const isContractor = job ? job.get('contractor') : isAContractor;

  const fourTensRuleEnabledInitialValue = useMemo(() => {
    if (job) {
      return !!job.get('four_tens_rule_enabled');
    }

    return fourTensRuleEnabledValue;
  }, [job, fourTensRuleEnabledValue]);

  const [fourTensRuleEnabled, setFourTensRuleEnabled] = useState(
    fourTensRuleEnabledInitialValue
  );

  const handleFourTensRuleEnabledChange = useCallback(
    e => {
      const value = e.target.checked;
      setFourTensRuleEnabled(value);
      setFieldValue('four_tens_rule_enabled', value);
    },
    [setFieldValue]
  );

  if (isContractor || stateCode !== 'NV') {
    return null;
  }

  return (
    <>
      <Box mb={8} className={cxEl('four_tens_rule_enabled')}>
        <Box
          row={!verticalLayout}
          column={verticalLayout}
          vcenter
          h={verticalLayout ? 'auto' : 68}
        >
          <Box>
            <Box row vcenter>
              <Checkbox
                disabled={!editMode}
                checked={!!fourTensRuleEnabled}
                name="four_tens_rule_enabled"
                className="four_tens_rule_checkbox"
                onChange={handleFourTensRuleEnabledChange}
              />
              <Text i18n="team.employee_profile.access_wages.nevada_four_ten_overtime.label" />
            </Box>

            <Box ml={42} row vcenter>
              <Text
                variant="bodySm"
                i18n="team.employee_profile.access_wages.nevada_four_ten_overtime.desc"
              />
              &nbsp;
              <Link href={NEVADA_LABOR_LAWS_URL} target="_blank" size="small">
                {toI18n('team.employee_profile.access_wages.learn_more')}
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

NevadaLaborSettings.propTypes = {
  editMode: PropTypes.bool,
  stateCode: PropTypes.string,
  cxEl: PropTypes.func.isRequired,
  job: PropTypes.object,
  isAContractor: PropTypes.bool,
  fourTensRuleEnabledValue: PropTypes.bool,
  verticalLayout: PropTypes.bool,
  setFieldValue: PropTypes.func,
};

export default connect(
  state => ({
    stateCode: getCurrentLocationStateName(state),
  }),
  {}
)(NevadaLaborSettings);
